import React from 'react'
import ReactDOM from 'react-dom';
import MapZoom from './MapZoom'

//App
const reactContainer = document.querySelector('#react-app');

const  App = ()=> {
  return (
	<MapZoom />
  )
}


// if (reactContainer) {
	ReactDOM.render(<App />, reactContainer);
// }
